module.exports = __webpack_public_path__ + "img/IMG_1176.52cb48e2.jpg";